// Horseshoe Icon Component
import React from 'react';

const HorseshoeIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 4 L6 10 C6 14.4 8.7 18 12 18 C15.3 18 18 14.4 18 10 L18 4" />
  </svg>
);

export default HorseshoeIcon;